// Get a list of your products and pop them into a dropdownlist
        function GetProducts() {
            var products = V12.getFinanceProducts();
            var ddlProducts = document.getElementById('productsList');
            for (var i = 0; i < products.length; i++) {
                var productName = products[i].name;
                
                // Override the default BNPL name completely
                if (productName.indexOf('Buy Now Pay Later') !== -1) {
                    productName = 'Buy Now, Pay Later (6-120 months) 11.9%';
                } else if (productName.match(/\d+\.\d+$/)) {
                    // Fix missing % sign from V12 API for other product names ending in a decimal
                    productName += '%';
                }

                var newItem = new Option(productName, products[i].productId);
                ddlProducts.appendChild(newItem);
            }
        }

        // Get details of repayments for the product selected
        function CalculateRepayments() {
            var productId = $('#productsList').val(); // selected product
            var financeProduct = V12.getFinanceProduct(productId); // get the object
            var cashPrice = parseFloat($('#cashPrice').val()) || 0;
            var depositAmount = parseFloat($('#deposit').val()) || 0;
            
            // Prevent deposit from exceeding 50% of product price
            var maxDeposit = cashPrice / 2;
            if (depositAmount > maxDeposit) {
                depositAmount = maxDeposit;
                $('#deposit').val(depositAmount);
                $('#depRange').val(depositAmount);
            }

            // Update live deposit % display
            var depositPercentage = (cashPrice > 0) ? (depositAmount / cashPrice) * 100 : 0;
            $('#depositAmountDisplay').html(depositPercentage.toFixed(1) + '%');

            var payments = V12.calculate(financeProduct, cashPrice, depositAmount);
            PopulateDescription(payments);
        }

        function UpdateLoanInfo() {
            $('#cashPrice').val($('#cpRange').val());
            $('#deposit').val($('#depRange').val());
            CalculateRepayments();
        }

        // Show repayment plan details in the description
        function PopulateDescription(payments) {
            $('#lblHeadlinePayment').html('&pound;' + payments.initialPayments + ' per month');

            var summaryText = 'Total product price: &pound;' + payments.cashPrice + '. ';
            
            if (payments.deposit > 0) {
                summaryText += '&pound;' + payments.deposit + ' deposit. ';
            }
            
            summaryText += 'Amount of credit: &pound;' + payments.loanAmount + '. ';
            $('#lblSummary').html(summaryText);

            var repayableText = '';
            if (payments.monthsDeferred > 0) {
                repayableText = 'Non-payment period ' + payments.monthsDeferred + ' months, followed by ';
            } else {
                repayableText = 'Repayable by ';
            }

            if (payments.initialPayments != payments.finalPayment && payments.finalPayment > 0) {
                repayableText += (payments.months - 1) + ' monthly repayments of &pound;' + payments.initialPayments + ' and a final payment of &pound;' + payments.finalPayment + '. ';
            } else {
                repayableText += payments.months + ' monthly repayments of &pound;' + payments.initialPayments + '. ';
            }

            $('#lblRepayable').html(repayableText);
            
            var ratesText = 'Representative APR ' + payments.apr + '%. Annual rate of interest ' + payments.annualRate + '% fixed. ';
            if (payments.documentFee > 0) {
                ratesText += 'Arrangement fee &pound;' + payments.documentFee + '. ';
            }
            if (payments.settlementFee > 0) {
                ratesText += 'Settlement fee &pound;' + payments.settlementFee + '. ';
            }
            $('#lblRatesAndFees').html(ratesText);

            $('#lblTotalRepayable').html('Total amount repayable &pound;' + payments.amountPayable + ' including total interest of &pound;' + payments.interest + '.');

            if (payments.monthsDeferred > 0 && payments.name.indexOf('Buy Now Pay Later') >= 0) {
                $('#lblBnpl').html('If you pay the amount of credit plus the settlement fee of &pound;' + payments.settlementFee +
                    ' by the end of the non-payment period, you will pay no interest. If you have not paid the amount of credit in full before the end of the non-payment period the &pound;' + payments.settlementFee + ' fee will not be payable but interest (at the rate specified above) will be charged on the outstanding credit amount, from the date we told you your agreement was live.');
                $('#lblBnpl').css("display", "");
            } else {
                $('#lblBnpl').css("display", "none");
            }
        }

        $(document).ready(function () {
            GetProducts();
            
            // Set initial max for deposit slider based on default cash price
            $('#depRange').attr('max', $('#cashPrice').val() / 2);
            CalculateRepayments();
            
            $('#productsList').on('change', function () {
                CalculateRepayments();
            });
            
            $('#cpRange, #depRange').on("input", function () {
                // Update max deposit range to 50% of current cash price
                $('#depRange').attr('max', $('#cpRange').val() / 2);
                UpdateLoanInfo();
            });
            
            $('#cashPrice, #deposit').keyup(function () {
                var cp = $('#cashPrice').val();
                var dep = $('#deposit').val();
                $('#cpRange').val(cp);
                $('#depRange').attr('max', cp / 2);
                $('#depRange').val(dep);
                CalculateRepayments();
            });
        });